import React from "react"
import { Badge, FormGroup, Input, Label, ListGroupItem } from "reactstrap"

/**
 * Fila de la lista "Capacidades del módulo" del modal de Importación Masiva:
 * badge + título + descripción (texto o nodos) a la izquierda y checkbox "Activar" a la derecha.
 */
const FilaCapacidad = ({
  badge,
  titulo,
  descripcion,
  checkId,
  checked,
  onChange,
  testId,
  tituloId,
  inputProps,
  deshabilitada = false,
  nota = null,
}) => (
  <ListGroupItem
    className="d-flex align-items-center justify-content-between"
    data-testid={testId}
  >
    <div className="d-flex align-items-center flex-grow-1">
      <Badge color={badge.color} className="me-3 flex-shrink-0">
        {badge.texto}
      </Badge>
      <div>
        <strong id={tituloId}>{titulo}</strong>
        <br />
        <small className="text-muted">{descripcion}</small>
        {/* BDSJEA-441: por qué no se puede usar (p. ej. «solo con Productores»). */}
        {nota && (
          <small
            id={checkId ? `${checkId}-nota` : undefined}
            className="text-muted d-block fst-italic"
            data-testid={testId ? `${testId}-nota` : undefined}
          >
            {nota}
          </small>
        )}
      </div>
    </div>
    <FormGroup check className="mb-0 ms-3 flex-shrink-0">
      <Input
        type="checkbox"
        id={checkId}
        checked={checked}
        disabled={deshabilitada}
        aria-describedby={nota && checkId ? `${checkId}-nota` : undefined}
        onChange={e => onChange(e.target.checked)}
        {...inputProps}
      />
      <Label check for={checkId} className="text-muted small">
        Activar
      </Label>
    </FormGroup>
  </ListGroupItem>
)

export default FilaCapacidad
